import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { ImageSlider } from "@/components/UI/ImageSlider";
import { FarbweltBanner } from "@/components/utilsComponents";
import { Tags } from "@/components/Tags";
import { useRefsContext } from "@/contexts/ref";
import { usePreviewGallery } from "@/gallery/hooks";
export const MobilePreview = ({ openModal, testId }) => {
    const { mobilePreview } = useRefsContext();
    const { mobilePreviewItems, itemsCount } = usePreviewGallery();
    const mobilePreviewTestId = `${testId}-mobile-preview`;
    return (_jsxs(_Fragment, { children: [_jsxs(Box, { ref: mobilePreview.ref, onClick: openModal, cursor: itemsCount > 0 ? "pointer" : "default", width: "100%", position: "relative", display: { "breakpoint.base": "block", "breakpoint.lg": "none" }, testId: mobilePreviewTestId, unsafe_className: "MobilePreview", children: [_jsx(ImageSlider, { images: mobilePreviewItems, a11yLabel: "" }), _jsx(Box, { position: "absolute", bottom: "spacing.32", left: "spacing.16", zIndex: "zIndex.1", children: _jsx(Tags, {}) })] }), _jsx(FarbweltBanner, {})] }));
};
